export const ROLE = {
    ADMIN: "ROLEADMIN",
    FARMER: "ROLEFARMER",
    SUPPLIER: "ROLESUPPLIER",
    TENANT: "ROLETENANT",
    AGRONOMIST: "ROLEAGRONOMIST",
    SOILANALYSISREPORT: "ROLESOILANALYSISREPORT",
};